/**
 * @file 隐藏的 input 组，用于导入文件
 */
import {FC, useLayoutEffect, useRef} from 'react';

import * as store from '@/store';
import {FileType, UPLOAD_FILE_ACCEPT_MAP} from '@/constants/document/file';
import {useUploadFile} from '@/hooks/document/useUploadFile';
import type {UploadInputOptions} from '@/types/document/file';

import styles from './index.module.scss';

interface UploadInputProps {
    uploadInputOptions?: UploadInputOptions;
}

const UploadInput: FC<UploadInputProps> = ({uploadInputOptions}) => {
    const uploadExcelRef = useRef<HTMLInputElement>(null);
    const uploadPPTRef = useRef<HTMLInputElement>(null);
    const uploadWordRef = useRef<HTMLInputElement>(null);
    const uploadPDFRef = useRef<HTMLInputElement>(null);
    const uploadExcelDstRef = useRef<HTMLInputElement>(null);

    const {uploadFile} = useUploadFile();

    /**
    * 导入文件，转换为在线文档
    */
    const handleUpload = async (e: any) => {
        if (!uploadInputOptions) {
            return;
        }

        const {target} = e;

        uploadFile(target.files, uploadInputOptions);
        switch (uploadInputOptions.fileType) {
            case FileType.Excel:
                (uploadExcelRef.current as HTMLInputElement).value = '';
                break;
            case FileType.PPT:
                (uploadPPTRef.current as HTMLInputElement).value = '';
                break;
            case FileType.Word:
                (uploadWordRef.current as HTMLInputElement).value = '';
                break;
            case FileType.PDF:
                (uploadPDFRef.current as HTMLInputElement).value = '';
                break;
            case FileType.ExcelDst:
                (uploadExcelDstRef.current as HTMLInputElement).value = '';
                break;
            default:
                break;
        }
    };

    /**
    * 点击导入事件
    * @param fileType 文件类型
    */
    const handleClickImportFile = (uploadInputOptions: UploadInputOptions) => {
        const {fileType} = uploadInputOptions;
        switch (fileType) {
            case FileType.Excel:
                if (uploadExcelRef?.current) {
                    uploadExcelRef.current.click();
                }
                break;
            case FileType.PPT:
                if (uploadPPTRef?.current) {
                    uploadPPTRef.current.click();
                }
                break;
            case FileType.Word:
                if (uploadWordRef?.current) {
                    uploadWordRef.current.click();
                }
                break;
            case FileType.PDF:
                if (uploadPDFRef?.current) {
                    uploadPDFRef.current.click();
                }
                break;
            case FileType.ExcelDst:
                if (uploadExcelDstRef?.current) {
                    uploadExcelDstRef.current.click();
                }
                break;
            default:
                break;
        }
    };

    useLayoutEffect(() => {
        uploadInputOptions && handleClickImportFile(uploadInputOptions);
    }, [uploadInputOptions]);

    return (
        <div className={styles.wrapper}>
            <input
                className={styles.upload}
                ref={uploadExcelRef}
                onChange={handleUpload}
                type={'file'}
                accept={UPLOAD_FILE_ACCEPT_MAP[FileType.Excel]}
                multiple
            />
            <input
                className={styles.upload}
                ref={uploadPPTRef}
                onChange={handleUpload}
                type={'file'}
                accept={UPLOAD_FILE_ACCEPT_MAP[FileType.PPT]}
                multiple
            />
            <input
                className={styles.upload}
                ref={uploadWordRef}
                onChange={handleUpload}
                type={'file'}
                accept={UPLOAD_FILE_ACCEPT_MAP[FileType.Word]}
                multiple
            />
            <input
                className={styles.upload}
                ref={uploadPDFRef}
                onChange={handleUpload}
                type={'file'}
                accept={UPLOAD_FILE_ACCEPT_MAP[FileType.PDF]}
                multiple
            />
            <input
                className={styles.upload}
                ref={uploadExcelDstRef}
                onChange={handleUpload}
                type={'file'}
                accept={UPLOAD_FILE_ACCEPT_MAP[FileType.ExcelDst]}
                multiple
            />
        </div>
    );
};


export default store.connect([
    store.KEYS.UPLOAD_INPUT_OPTIONS,
])(UploadInput);
